// import { components } from "react-select";
import NoteReviewScreen from "../notereview/NoteReviewScreen";
import FormsStation from "../landingscreen/patientcharts/tabs/forms/FormsStation";
import FormInboxPage from "../forms/staff/FormInboxPage";
import FormSettingsPage from "../forms/staff/FormSettingsPage";
// import Forgotpassword from "../auth/forgotpassword/forgotpassword";
// import ResetPassword from "../auth/forgotpassword/resetpassword";
// import { LogIn } from "../auth/login";
// import Fax from "../fax/fax";
// import HelloDev from "../hellodev";
// import CareLanding from "../landingscreen/brainycarehome";
// import Orders from "../orders/orders";
// import RpmDevices from "../rpm/devices/rpmdevices";
// import rpmreports from "../rpm/devices/rpmreports";
// import Rpm from "../rpm/rpm";
// import Schedule from "../schedule/schedule";
// import SigninTab from "../signin/signin";
// import Procedures from "../tabs/procedures/procedures";
// import Refills from "../tabs/refills/refills";
// import Tasks from "../tasks/tasks";
// import UserTab from "../user/user";
// import rpmAnalytics from "../rpm/devices/rpmAnalytics";
// import Reporthome from "../Reports/Reporthome";
// import Editscreen from "../blinkscribe/archeivescreens/editscreen";
// import Waitinghome from "../WaitingRoom/Waitinghome";
// import ExpireResetPassword from "../auth/forgotpassword/Passwordexpire";
// import Inventory from "../inventory/inventory";
// import Onboarding from "../onboarding/onboarding";
// import ColorCoding from "../colorcoding/colorcoding";
// import ThyroidUltrasoundview from "../Forms/views/thyroidultrasound";
// import AbdominalUltrasoundview from "../Forms/views/abdominalultrsoundview";
// import AbdominalUltrasoundDopplerview from "../Forms/views/abdominalultrasounddopplerview";
// import AortaUltrasoundview from "../Forms/views/AortaultrasounndView";
// import BladderUltrasoundviewPreliminary from "../Forms/views/bladderultrasoundpreliminaryview";
// import BreastUltraSoundView from "../Forms/views/breastultrsoundview";
// import RenalDopplerView from "../Forms/views/renaldopplerview";
// import LowerExtremelyVenousDopplerView from "../Forms/views/lowerextremelyvenousview";
// import TestucularUltrasoundview from "../Forms/views/testicularultrasoundview";

// import ProTransAbdominalView from "../Forms/views/protransabdominalview";
// import OrthoultrasoundView from "../Forms/views/orthoultrasoundview";
// import EstimView from "../Forms/views/estimview";
// import ManageProfile from "../pages/manageprofile/ManageProfile";
// import PelvicView from "../Forms/views/pelvicView";
// import PatientOnboarding from "../patientonboarding/PatientOnboarding";

// import CCMScreen from "../ccm/ccm";
// import FacialRecognization from "../facialrecognization/onBoarding/onBoarding";
// import ViewOnBoardEmployees from "../facialrecognization/views/Viewonboardemp";
// import EmployeeTimesheets from "../timesheets/employeeTimesheet/employeetimesheets";
// import HomesleepLink from "../landingscreen/patientcharts/tabs/forms/sharablehtmls/homesleepq";
// import DocumentLinkSwitcher from "../landingscreen/patientcharts/tabs/forms/sharablehtmls/documentlinkswitcher";
// import PatientOnboarding111 from "../patientonboarding/patientonboarding1111";
// import PatientOnboardingpublic from "../patientonboarding/patientonboardingpublic";
// import MedTrack from "../MedTrack/MedTrack";
// import Logs from "../logs/log";

// export const routes = [
//   {
//     path: '/landing',
//     component: CareLanding,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/login',
//     component: LogIn,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/forgotpassword',
//     component: Forgotpassword,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/reset-password/:id',
//     component: ExpireResetPassword,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/reset/:token',
//     component: ResetPassword,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/pro',
//     component: Procedures,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/ref',
//     component: Refills,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/dev',
//     component: HelloDev,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/usthyroid-Preview/:filename',
//     component: ThyroidUltrasoundview,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/usabdominal-Preview/:filename',
//     component: AbdominalUltrasoundview,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/usabdominal-doppler-Preview/:filename',
//     component: AbdominalUltrasoundDopplerview,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/usaorta-Preview/:filename',
//     component: AortaUltrasoundview,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/bladderPreliminary-Preview/:filename',
//     component: BladderUltrasoundviewPreliminary,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/breastus-Preview/:filename',
//     component: BreastUltraSoundView,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/renalDopplerus-Preview/:filename',
//     component: RenalDopplerView,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/LwrExtrmVnsDpler-Preview/:filename',
//     component: LowerExtremelyVenousDopplerView,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/testicularUltrasound-Preview/:filename',
//     component: TestucularUltrasoundview,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/testicularUltrasound-Preview/:filename',
//     component: TestucularUltrasoundview,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/prostateTransAbdominal-Preview/:filename',
//     component: ProTransAbdominalView,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/orthous-Preview/:filename',
//     component: OrthoultrasoundView,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/estim-Preview/:filename',
//     component: EstimView,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/imaging/uspelvic-Preview/:filename',
//     component: PelvicView,
//     showHeader: false,
//     privilege: ''
//   },
//    {
//     path: '/doc/:type/:patientid/:filename',
//     component:DocumentLinkSwitcher,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/orders/:id/:dt/:filter',
//     component: Orders,
//     showHeader: true,
//     privilege: ''
//   },
//   //  {
//   //     path: '/careiq',
//   //     component: CareIq,
//   //     showHeader: true,
//   //     privilege: ''
//   //   },
//   {
//     path: '/rpm',
//     component: Rpm,
//     showHeader: true,
//     privilege: 'RPM'
//   },
//   {
//     path: '/rpm-devices',
//     component: RpmDevices,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/rpm-reports',
//     component: rpmreports,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/rpm-analytics',
//     component: rpmAnalytics,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/waiting-room',
//     component: Waitinghome,
//     showHeader: false,
//     privilege: ''
//   },
//   {
//     path: '/signtab',
//     component: SigninTab,
//     showHeader: true,
//     privilege: 'SignIn Sheet'
//   },
//   {
//     path: '/reports',
//     component: Reporthome,
//     showHeader: true,
//     privilege: 'Reports'
//   },
//   {
//     path: '/user',
//     component: UserTab,
//     showHeader: true,
//     privilege: 'Users'
//   },
//   {
//     path: '/tasks',
//     component: Tasks,
//     showHeader: true,
//     privilege: 'Tasks'
//   },
//   {
//     path: '/fax',
//     component: Fax,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/schedule',
//     component: Schedule,
//     showHeader: true,
//     privilege: 'Scheduler'
//   },

//   {
//     path: '/archive-edit/:id/:name',
//     component: Editscreen,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/inventory',
//     component: Inventory,
//     showHeader: true,
//     privilege: 'Inventory'
//   },
//   {
//     path: '/logs',
//     component:Logs,
//     showHeader: true,
//     privilege: 'Logs'
//   },
//   {
//     path: '/onboarding',
//     component: Onboarding,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/manage-profile',
//     component: ManageProfile,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/patient',
//     component: PatientOnboarding,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/patient1111',
//     component: PatientOnboarding111,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/patient-enrollment',
//     component: PatientOnboardingpublic,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/colorcode',
//     component: ColorCoding,
//     showHeader: true,
//     privilege: ''
//   },
//    {
//     path: '/ccm',
//     component: CCMScreen,
//     showHeader: true,
//     privilege: ''
//   },

//    {
//     path: '/onboard-emp',
//     component:FacialRecognization,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/view-emp',
//     component:ViewOnBoardEmployees,
//     showHeader: true,
//     privilege: ''
//   },
//    {
//     path: '/timesheets',
//     component:EmployeeTimesheets,
//     showHeader: true,
//     privilege: ''
//   },
//   {
//     path: '/medtrack/:ak',
//     component: MedTrack,
//     showHeader: false,
//     privilege: ''
//   }
// ];

import { components } from "react-select";
import Forgotpassword from "../auth/forgotpassword/forgotpassword";
import ResetPassword from "../auth/forgotpassword/resetpassword";
import { LogIn } from "../auth/login";
import Fax from "../fax/fax";
import HelloDev from "../hellodev";
import CareLanding from "../landingscreen/brainycarehome";
import Orders from "../orders/orders";
import RpmDevices from "../rpm/devices/rpmdevices";
import rpmreports from "../rpm/devices/rpmreports";
import Rpm from "../rpm/rpm";
import RpmBilling from "../rpm/rpmbilling";
import NewDashboard from "../landingscreen/newdash/NewDashboard";
import Schedule from "../schedule/schedule";
import SigninTab from "../signin/signin";
import Procedures from "../tabs/procedures/procedures";
import Refills from "../tabs/refills/refills";
import Tasks from "../tasks/tasks";
import UserTab from "../user/user";
import rpmAnalytics from "../rpm/devices/rpmAnalytics";
import Reporthome from "../Reports/Reporthome";
import Editscreen from "../blinkscribe/archeivescreens/editscreen";
import Waitinghome from "../WaitingRoom/Waitinghome";
import ExpireResetPassword from "../auth/forgotpassword/Passwordexpire";
import Inventory from "../inventory/inventory";
import Onboarding from "../onboarding/onboarding";
import ColorCoding from "../colorcoding/colorcoding";
import ThyroidUltrasoundview from "../Forms/views/thyroidultrasound";
import AbdominalUltrasoundview from "../Forms/views/abdominalultrsoundview";
import AbdominalUltrasoundDopplerview from "../Forms/views/abdominalultrasounddopplerview";
import AortaUltrasoundview from "../Forms/views/AortaultrasounndView";
import BladderUltrasoundviewPreliminary from "../Forms/views/bladderultrasoundpreliminaryview";
import BreastUltraSoundView from "../Forms/views/breastultrsoundview";
import RenalDopplerView from "../Forms/views/renaldopplerview";
import LowerExtremelyVenousDopplerView from "../Forms/views/lowerextremelyvenousview";
import TestucularUltrasoundview from "../Forms/views/testicularultrasoundview";
import EchoView from "../Forms/views/echoview";
import CarotidView from "../Forms/views/carotidview";
import VenousView from "../Forms/views/venousview";
import ArterialView from "../Forms/views/arterialview";

import ProTransAbdominalView from "../Forms/views/protransabdominalview";
import OrthoultrasoundView from "../Forms/views/orthoultrasoundview";
import EstimView from "../Forms/views/estimview";
import ManageProfile from "../pages/manageprofile/ManageProfile";
import PelvicView from "../Forms/views/pelvicView";
import PatientOnboarding from "../patientonboarding/PatientOnboarding";

import CCMScreen from "../ccm/ccm";
import FacialRecognization from "../facialrecognization/onBoarding/onBoarding";
import ViewOnBoardEmployees from "../facialrecognization/views/Viewonboardemp";
import EmployeeTimesheets from "../timesheets/employeeTimesheet/employeetimesheets";
import HomesleepLink from "../landingscreen/patientcharts/tabs/forms/sharablehtmls/homesleepq";
import DocumentLinkSwitcher from "../landingscreen/patientcharts/tabs/forms/sharablehtmls/documentlinkswitcher";
import PatientOnboarding111 from "../patientonboarding/patientonboarding1111";
import PatientOnboardingpublic from "../patientonboarding/patientonboardingpublic";
import MedTrack from "../MedTrack/MedTrack";
import Logs from "../logs/log";
import StrepCovidFluView from "../Forms/views/StrepCovidFluView";
import Prices from "../prices/price";
import BillingModule from "../billing/BillingModule";
import InterpReview from "../interpreview/InterpReview";
import PrintNotes from "../printnotes/PrintNotes";
import { isRouteForPractice, practiceFeatures } from "../config/practice";
import OsaMessaging from "../fax/osaMessaging";
import VapiCallLogs from "../logs/vapiCallLogs";
import WebInquiry from "../webinquiry/webinquiry";
import Rooms from "../rooms/Rooms";
import { boardsNavRouteAllowed, bsAccessOnly, roomsAdmin } from "../config/practice";
import { screenPrivileges } from "../config/screenPrivileges";
import { withBsAccess } from "../utils/BsAccessGate";
import FormsPreviewRoute from "../forms/preview/FormsPreviewRoute";
import PatientFormsRoute from "../forms/patient/PatientFormsRoute";
import InboxPage from "../inbox/InboxPage";
import { inboxOrOldPage } from "../inbox/InboxRedirect";
import { practiceInboxQueues, routePrivilege } from "../inbox/inboxQueues";

// Unified Inbox (features.unifiedInbox, owner 10-20): /fax, /onboarding and
// /messaging only redirect into /inbox; off (7825), they are the pages as before.
const oldInboxPage = (path, component) => inboxOrOldPage(path, component);

export const routes = [
  {
    // The real dashboard — full functionality. The redesign is applied to
    // THIS component tree in place, area by area, so nothing goes missing.
    path: "/landing",
    component: CareLanding,
    showHeader: true,
    privilege: "",
  },
  {
    // Layout-only render of the design guideline (reference while restyling).
    path: "/dashboard-preview",
    component: NewDashboard,
    showHeader: true,
    privilege: "",
  },
  {
    // Dev-only Form Wizard preview (Step 1). Gated to preview/dev hosts in
    // FormsPreviewRoute and linked from nowhere; the renderer is a lazy chunk.
    path: "/forms-preview",
    component: FormsPreviewRoute,
    showHeader: false,
    privilege: "",
  },
  {
    // Form Wizard patient page: public (no sign-in; "/f/" is in
    // unrestrictedRoutes), no header. Links are /f/#<practiceid>_<secret>.
    path: "/f",
    component: PatientFormsRoute,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/login",
    component: LogIn,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/forgotpassword",
    component: Forgotpassword,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/reset-password/:id",
    component: ExpireResetPassword,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/reset/:token",
    component: ResetPassword,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/pro",
    component: Procedures,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/ref",
    component: Refills,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/dev",
    component: HelloDev,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/usthyroid-Preview/:filename",
    component: ThyroidUltrasoundview,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/usabdominal-Preview/:filename",
    component: AbdominalUltrasoundview,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/usabdominal-doppler-Preview/:filename",
    component: AbdominalUltrasoundDopplerview,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/usaorta-Preview/:filename",
    component: AortaUltrasoundview,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/bladderPreliminary-Preview/:filename",
    component: BladderUltrasoundviewPreliminary,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/breastus-Preview/:filename",
    component: BreastUltraSoundView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/renalDopplerus-Preview/:filename",
    component: RenalDopplerView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/LwrExtrmVnsDpler-Preview/:filename",
    component: LowerExtremelyVenousDopplerView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/testicularUltrasound-Preview/:filename",
    component: TestucularUltrasoundview,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/testicularUltrasound-Preview/:filename",
    component: TestucularUltrasoundview,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/prostateTransAbdominal-Preview/:filename",
    component: ProTransAbdominalView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/orthous-Preview/:filename",
    component: OrthoultrasoundView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/estim-Preview/:filename",
    component: EstimView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/imaging/uspelvic-Preview/:filename",
    component: PelvicView,
    showHeader: false,
    privilege: "",
  },
    {
    path: '/imaging/echo-Preview/:filename',
    component: EchoView,
    showHeader: false,
    privilege: ''
  },
    {
    path: '/imaging/carotid-Preview/:filename',
    component: CarotidView,
    showHeader: false,
    privilege: ''
  },
    {
    path: '/imaging/venous-Preview/:filename',
    component: VenousView,
    showHeader: false,
    privilege: ''
  },
    {
    path: '/imaging/arterial-Preview/:filename',
    component: ArterialView,
    showHeader: false,
    privilege: ''
  }, 
  {
    path: "/doc/:type/:patientid/:filename",
    component: DocumentLinkSwitcher,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/orders/:id/:dt/:filter",
    component: Orders,
    showHeader: true,
    privilege: "",
  },
  //  {
  //     path: '/careiq',
  //     component: CareIq,
  //     showHeader: true,
  //     privilege: ''
  //   },
  {
    path: "/rpm",
    component: Rpm,
    showHeader: true,
    privilege: "RPM",
  },
  {
    path: "/rpm-billing",
    component: RpmBilling,
    showHeader: true,
    privilege: "RPM",
  },
  {
    path: "/rpm-devices",
    component: RpmDevices,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/rpm-reports",
    component: rpmreports,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/rpm-analytics",
    component: rpmAnalytics,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/waiting-room",
    component: Waitinghome,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/signtab",
    component: SigninTab,
    showHeader: true,
    privilege: "SignIn Sheet",
  },
  {
    path: "/note-review",
    // 7825: only for a user with BlinkScribe in the practice (OSA batch 6).
    component: bsAccessOnly("Note Review") ? withBsAccess(NoteReviewScreen) : NoteReviewScreen,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/print-notes",
    component: bsAccessOnly("Print Notes") ? withBsAccess(PrintNotes) : PrintNotes,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/forms",
    component: FormsStation,
    showHeader: true,
    privilege: "",
  },
  {
    // Form Wizard review queue; "Page not available" unless
    // practiceFeatures().formWizard.
    path: "/form-inbox",
    component: FormInboxPage,
    showHeader: true,
    privilege: "",
  },
  {
    // Form Wizard settings: the "Form Settings" privilege or "Users"
    // (owner 11-03 split; config/screenPrivileges.js).
    path: "/form-settings",
    component: FormSettingsPage,
    showHeader: true,
    privilege: "Users",
    privilegeAny: screenPrivileges("formSettings"),
  },
  {
    path: "/reports",
    component: Reporthome,
    showHeader: true,
    privilege: "Reports",
  },
  {
    path: "/user",
    component: UserTab,
    showHeader: true,
    privilege: "Users",
  },
  {
    path: "/tasks",
    component: Tasks,
    showHeader: true,
    privilege: "Tasks",
  },
  {
    path: "/imaging/strep-covid-flu-Preview/:filename",
    component: StrepCovidFluView,
    showHeader: false,
    privilege: "",
  },
  {
    path: "/fax",
    component: oldInboxPage("/fax", Fax),
    showHeader: true,
    privilege: "",
  },
  // The unified Inbox, one route per queue (src/inbox/inboxQueues.js): a
  // one-privilege queue is gated here; All open and the Requests queue
  // (Onboarding OR Communication) by the page itself. isRouteForPractice drops them unless features.unifiedInbox.
  ...practiceInboxQueues().map((q) => ({
    path: q.path,
    component: InboxPage,
    showHeader: true,
    privilege: routePrivilege(q),
  })),
  {
    path: "/schedule",
    component: Schedule,
    showHeader: true,
    privilege: "Scheduler",
  },

  {
    path: "/archive-edit/:id/:name",
    component: Editscreen,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/inventory",
    component: Inventory,
    showHeader: true,
    privilege: "Inventory",
  },
  {
    path: "/logs",
    // 7825: OSA's Vapi call log; 9928 keeps its OTP log.
    component: practiceFeatures().vapiCallLogs ? VapiCallLogs : Logs,
    showHeader: true,
    privilege: "Logs",
  },
  {
    path: "/onboarding",
    component: oldInboxPage("/onboarding", Onboarding),
    showHeader: true,
    privilege: "",
  },
  {
    path: "/manage-profile",
    component: ManageProfile,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/patient",
    component: PatientOnboarding,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/patient1111",
    component: PatientOnboarding111,
    showHeader: true,
    privilege: "",
  },
  {
    // Legacy Dallas texted link — now runs the SAME modern 9928 flow as
    // Odessa, stamping department 2 (1111/OpenEMR intake retired 2026-08-20).
    path: "/patient-enrollment",
    component: PatientOnboarding,
    showHeader: true,
    privilege: "",
  },
  {
    // Obvious per-location links for new texts (Teja request 2026-08-20).
    path: "/onboard-odessa",
    component: PatientOnboarding,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/onboard-frisco",
    component: PatientOnboarding,
    showHeader: true,
    privilege: "",
  },
  {
    // CODE (Athena dept 3 of 9928, 2026-11-01): stamps department 3
    // (config/practice.js intakeDepartmentId).
    path: "/onboard-code",
    component: PatientOnboarding,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/colorcode",
    component: ColorCoding,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/ccm",
    component: CCMScreen,
    showHeader: true,
    privilege: "",
  },

  {
    path: "/onboard-emp",
    component: FacialRecognization,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/view-emp",
    component: ViewOnBoardEmployees,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/timesheets",
    component: EmployeeTimesheets,
    showHeader: true,
    privilege: "",
  },
  {
    path: "/medtrack/:ak",
    component: MedTrack,
    showHeader: false,
    privilege: "",
  },
    {
    path: "/prices",
    component: Prices,
    showHeader: true,
    privilege: "Prices",
  },
  {
    path: "/billing",
    component: BillingModule,
    showHeader: true,
    privilege: "Billing Module",
  },
  // Interpretation Review (9928): Dr. Madhu's blinded calibration + AI echo draft review. Study tool, never filed
  // to the chart; the server also checks the practice and the privilege on every call.
  {
    path: "/interp-review",
    component: InterpReview,
    showHeader: true,
    privilege: "Interpretation Review",
  },
  // OSA batch 5 (7825 only; isRouteForPractice drops them elsewhere).
  {
    path: "/messaging",
    component: oldInboxPage("/messaging", OsaMessaging),
    showHeader: true,
    privilege: "",
  },
  {
    path: "/webinquiry",
    component: WebInquiry,
    showHeader: true,
    privilege: "Website Inquiry",
  },
  // OSA batch 6: the Rooms page (7825 only; boardsNavRouteAllowed drops it
  // elsewhere), behind the profile's Side Bar privilege.
  {
    path: "/rooms",
    component: Rooms,
    showHeader: true,
    privilege: roomsAdmin()?.privilege || "",
    privilegeAny: roomsAdmin()?.privilegeAny || [],
  },
// 9928-only patient-intake routes (C-HIM consents, Dallas/1111) drop out
// elsewhere; batch 6 drops /rooms and the profile's hiddenPaths.
].filter((route) => isRouteForPractice(route.path) && boardsNavRouteAllowed(route.path));
